import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME,
} from '@modules/players-bonuses/constants';
import {
  ADMIN_PLAYERS_BONUSES_EDIT_ROUTE_NAME,
  TRANSLATION_PLAYER_BONUS_EDIT,
} from '@modules/players-bonuses/submodules/edit/constants';
import { getTranslationKeys } from '@modules/players-bonuses/submodules/edit/translations';

export class PlayerBonusesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME, {
      name: ADMIN_PLAYERS_BONUSES_EDIT_ROUTE_NAME,
      path: 'edit/:id',
      component: () => import('@modules/players-bonuses/submodules/edit/pages/PlayersBonusesEditPage/PlayersBonusesEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_PLAYER_BONUS_EDIT, getTranslationKeys);
  }
}
